// extracted by mini-css-extract-plugin
export var button = "_e5-4";
export var hasDarkBackground = "_e5-7";
export var hasLightBackground = "_e5-6";
export var iconWrapper = "_e5-0";
export var large = "_e5-2";
export var medium = "_e5-1";
export var small = "_e5-5";
export var xsmall = "_e5-3";